import React, { useState, useRef, useEffect } from 'react';
import { ApiCore } from '../../api/index';
import { Toast } from 'antd-mobile';
import reporting_body from '../../static/images_ae/reporting/reporting_body.png';
import area_head from '../../static/images_ae/reporting/area_head.png';
import area_chest from '../../static/images_ae/reporting/area_chest.png';
import area_stomach from '../../static/images_ae/reporting/area_stomach.png';
import area_others from '../../static/images_ae/reporting/area_others.png';
import area_four_limbs from '../../static/images_ae/reporting/area_four_limbs.png';
// import line_head from '../../static/images_ae/reporting/line_head.png';
// import line_chest from '../../static/images_ae/reporting/line_chest.png';
// import line_stomach from '../../static/images_ae/reporting/line_stomach.png';
// import line_four_limbs from '../../static/images_ae/reporting/line_four_limbs.png';
// import line_others from '../../static/images_ae/reporting/line_others.png';
import tip_top_select from '../../static/images_ae/reporting/tip_top_select.png';
import tip_bottom_select from '../../static/images_ae/reporting/tip_bottom_select.png';
import choose_sympton from '../../static/images_ae/alkReport/choose_sympton.png';
import btn_blue from '../../static/images_ae/alkReport/btn_blue.png';
import all_body_blue from '../../static/images_ae/alkReport/all_body_blue.png';
import all_body_purple from '../../static/images_ae/alkReport/all_body_purple.png';
import chest_blue from '../../static/images_ae/alkReport/chest_blue.png';
import chest_purple from '../../static/images_ae/alkReport/chest_purple.png';
import head_blue from '../../static/images_ae/alkReport/head_blue.png';
import head_purple from '../../static/images_ae/alkReport/head_purple.png';
import stomach_blue from '../../static/images_ae/alkReport/stomach_blue.png';
import stomach_purple from '../../static/images_ae/alkReport/stomach_purple.png';
import limbs_blue from '../../static/images_ae/alkReport/limbs_blue.png';
import limbs_purple from '../../static/images_ae/alkReport/limbs_purple.png';

import line_all_body from '../../static/images_ae/alkReport/line_all_body.png';
import line_chest from '../../static/images_ae/alkReport/line_chest.png';
import line_head from '../../static/images_ae/alkReport/line_head.png';
import line_limbs from '../../static/images_ae/alkReport/line_limbs.png';
import line_stomach from '../../static/images_ae/alkReport/line_stomach.png';
import right_db_arrow from '../../static/images_ae/alkReport/right_db_arrow.png';

import blue_body from '../../static/images_ae/alkReport/blue_body.png';
import icon_down_down from '../../static/images_ae/alkReport/icon_down_down.png';
import { withRouter } from 'react-router-dom';
import styles from './index.module.scss';
import Chest from './chest';
import Head from './head';
import FourLimbs from './fourLimbs';
import Others from './others';
import Stomach from './stomach';
import Completed from './completed';
import Result from './result';
import Degree from './degree';
import area_active_indicator_bg from '../../static/images_ae/alkReport/area_active_indicator_bg.png';
import delete_icon from '../../static/images_ae/alkReport/delete_icon.png';
import btn_six_side from '../../static/images_ae/alkReport/btn_six_side.png';
import bg_wrap_top from '../../static/images_ae/alkReport/bg_wrap_top.png';
import bg_wrap_bottom from '../../static/images_ae/alkReport/bg_wrap_bottom.png';

const api = new ApiCore();

const AeReporting = (props: any) => {

    const [headSelected, setHeadSelected] = useState<any>(false);
    const [chestSelected, setChestSelected] = useState<any>(false);
    const [stomachSelected, setStomachSelect] = useState<any>(false);
    const [othersSelected, setOthersSelected] = useState<any>(false);
    const [fourLimbsSelected, setFourLimbsSelected] = useState<any>(false);
    const [chestOrgans, setChestOrgans] = useState<any>([]);
    const [stomachOrgans, setStomachOrgans] = useState<any>([]);
    const [headOrgans, setHeadOrgans] = useState<any>([]);
    const [limbsOrgans, setLimbsOrgans] = useState<any>([]);
    const [othersOrgans, setOthersOrgans] = useState<any>([]);
    const [treatments, setTreatmentsList] = useState<any>([]);
    const [showBody, setShowBody] = useState<any>(false);
    const [showHead, setShowHead] = useState<any>(false);
    const [showChest, setShowChest] = useState<any>(false);
    const [showStomach, setShowStomach] = useState<any>(false);
    const [showLimbs, setShowLimbs] = useState<any>(false);
    const [showOthers, setShowOthers] = useState<any>(false);
    const [showCompleted, setShowCompleted] = useState<any>(false);
    const [showResult, setShowResult] = useState<any>(false);
    const [showDegree, setShowDegree] = useState<any>(false);
    const [headSelectCount, setHeadSelectCount] = useState<number>(0);
    const [chestSelectCount, setChestSelectCount] = useState<number>(0);
    const [stomachSelectCount, setStomachSelectCount] = useState<number>(0);
    const [othersSelectCount, setOthersSelectCount] = useState<number>(0);
    const [limbsSelectCount, setLimbsSelectCount] = useState<number>(0);
    const [bodySelectedCount, setBodySelectedCount] = useState<number>(0);
    const [selectedCount, setSelectedCount] = useState<number>(0);
    const [symptomsResult, setSymptomsResult] = useState<any>([]);
    const [commonSymptoms, setCommonSymptoms] = useState<any>([]);
    const [activeSymptoms, setActiveSymptoms] = useState<any>([]);
    const [symptomRecords, setSymptomsRecords] = useState<any>([]);
    const [isCommonSymptoms, setIsCommonSymptoms] = useState<any>(true);
    const [nowStep, setNowStep] = useState<any>(1);
    useEffect(() => {
        window.document.title = 'ALK风险评估';
        initData();
        return () => {
            window.removeEventListener('popstate', onPopState);
        }
    }, [])

    useEffect(() => {
        let _selectedCount = 0;
        [headSelected, chestSelected, stomachSelected, othersSelected, fourLimbsSelected].forEach((val: any) => {
            if (val) {
                _selectedCount++;
            }
        })
        setBodySelectedCount(_selectedCount);
    }, [headSelected, chestSelected, stomachSelected, othersSelected, fourLimbsSelected])

    useEffect(() => {
        let _selectedCount = 0;
        [headSelectCount, chestSelectCount, stomachSelectCount, othersSelectCount, limbsSelectCount].forEach((val: any) => {
            if (val) {
                _selectedCount += val;
            }
        })
        setSelectedCount(_selectedCount);
    }, [headSelectCount, chestSelectCount, stomachSelectCount, othersSelectCount, limbsSelectCount])

    useEffect(() => {
        const _showBody = [showHead, showChest, showStomach, showLimbs, showOthers, showCompleted, showResult, showDegree].every((val: any) => !val)
        setShowBody(_showBody);
        // setIsCommonSymptoms(_showBody);
    }, [showHead, showChest, showStomach, showLimbs, showOthers, showCompleted, showResult, showDegree])

    const initData = () => {
        window.addEventListener('popstate', onPopState)
        api.getEvaluationConfig().then((res: any) => {
            if (res.code == 0) {
                setTreatmentsList(res.data?.treatments || []);
                const _position = res.data?.positions || [];
                const _commonSymptoms: any = [];
                _position.forEach((val: any) => {
                    if (val.type == 'chest') {
                        setChestOrgans(val);
                    } else if (val.type == 'abdomen') {
                        setStomachOrgans(val);
                    } else if (val.type == 'head') {
                        setHeadOrgans(val);
                    } else if (val.type == 'limbs') {
                        setLimbsOrgans(val);
                    } else if (val.type == 'body') {
                        setOthersOrgans(val);
                    }
                    val.organs.forEach((val: any) => {
                        val.symptoms.forEach((vv: any) => {
                            if (vv.isCommon) {
                                _commonSymptoms.push(vv);
                            }
                        });
                    });
                });
                setCommonSymptoms(_commonSymptoms);
            }
        })
    }

    const onPopState = (event: any) => {
    }

    const headSelect = () => {
        // setHeadSelected(!headSelected);
        // setChestSelected(false);
        // setStomachSelect(false);
        // setOthersSelected(false);
        // setFourLimbsSelected(false);
        setShowHead(true);
    }

    const chestSelect = () => {
        // setChestSelected(!chestSelected);
        // setHeadSelected(false);
        // setStomachSelect(false);
        // setOthersSelected(false);
        // setFourLimbsSelected(false);
        // window.history.pushState({}, document.title, '#/ae/reporting');
        setShowChest(true);
    }

    const stomachSelect = () => {
        // setStomachSelect(!stomachSelected);
        // setHeadSelected(false);
        // setChestSelected(false);
        // setOthersSelected(false);
        // setFourLimbsSelected(false);
        // window.history.pushState({}, document.title, '#/ae/reporting');
        setShowStomach(true);
    }

    const othersSelect = () => {
        // setOthersSelected(!othersSelected);
        // setHeadSelected(false);
        // setChestSelected(false);
        // setStomachSelect(false);
        // setFourLimbsSelected(false);
        // window.history.pushState({}, document.title, '#/ae/reporting');
        setShowOthers(true);
    }

    const fourLimbsSelect = () => {
        // setFourLimbsSelected(!fourLimbsSelected);
        // setHeadSelected(false);
        // setChestSelected(false);
        // setStomachSelect(false);
        // setOthersSelected(false);
        // window.history.pushState({}, document.title, '#/ae/reporting');
        setShowLimbs(true);
    }

    const onBack = () => {
        setShowHead(false);
        setShowChest(false);
        setShowStomach(false);
        setShowOthers(false);
        setShowLimbs(false);
        setShowCompleted(false);
        setShowResult(false);
        setShowDegree(false);
        let _step = nowStep;
        if (_step > 1) {
            _step--;
            setNowStep(_step)
        }
    }

    const onComplete = (type: string, organList: any) => {
        if (type == 'head') {
            const _headOrgans = headOrgans;
            _headOrgans.organs = organList;
            setHeadOrgans(_headOrgans);
            let _count = 0;
            const _selectedMap = {};
            _headOrgans.organs.forEach((val: any) => {
                val.symptoms.forEach((v: any) => {
                    if (v.selected) {
                        _selectedMap[v.code] = v;
                        _count++;
                    }
                })
            })
            const _commonSymptoms = commonSymptoms.map((vvv: any) => {
                if (_selectedMap[vvv.code]) {
                    return {
                        ...vvv,
                        selected: true
                    }
                } else {
                    return {
                        ...vvv,
                        selected: false
                    }
                }
            });
            setCommonSymptoms(_commonSymptoms);
            setHeadSelectCount(_count);
            // onBack();
        } else if (type == 'chest') {
            const _chestOrgans = chestOrgans;
            _chestOrgans.organs = organList;
            setChestOrgans(_chestOrgans);
            let _count = 0;
            const _selectedMap = {};
            _chestOrgans.organs.forEach((val: any) => {
                val.symptoms.forEach((v: any) => {
                    if (v.selected) {
                        _selectedMap[v.code] = v;
                        _count++;
                    }
                })
            })
            const _commonSymptoms = commonSymptoms.map((vvv: any) => {
                if (_selectedMap[vvv.code]) {
                    return {
                        ...vvv,
                        selected: true
                    }
                } else {
                    return {
                        ...vvv,
                        selected: false
                    }
                }
            });
            setCommonSymptoms(_commonSymptoms);
            setChestSelectCount(_count);
            // onBack();
        } else if (type == 'abdomen') {
            const _stomachOrgans = stomachOrgans;
            _stomachOrgans.organs = organList;
            setStomachOrgans(_stomachOrgans);
            let _count = 0;
            const _selectedMap = {};
            _stomachOrgans.organs.forEach((val: any) => {
                val.symptoms.forEach((v: any) => {
                    if (v.selected) {
                        _selectedMap[v.code] = v;
                        _count++;
                    }
                })
            })
            const _commonSymptoms = commonSymptoms.map((vvv: any) => {
                if (_selectedMap[vvv.code]) {
                    return {
                        ...vvv,
                        selected: true
                    }
                } else {
                    return {
                        ...vvv,
                        selected: false
                    }
                }
            });
            setCommonSymptoms(_commonSymptoms);
            setStomachSelectCount(_count);
            // onBack();
        } else if (type == 'body') {
            const _othersOrgans = othersOrgans;
            _othersOrgans.organs = organList;
            setOthersOrgans(_othersOrgans);
            let _count = 0;
            const _selectedMap = {};
            _othersOrgans.organs.forEach((val: any) => {
                val.symptoms.forEach((v: any) => {
                    if (v.selected) {
                        _selectedMap[v.code] = v;
                        _count++;
                    }
                })
            })
            const _commonSymptoms = commonSymptoms.map((vvv: any) => {
                if (_selectedMap[vvv.code]) {
                    return {
                        ...vvv,
                        selected: true
                    }
                } else {
                    return {
                        ...vvv,
                        selected: false
                    }
                }
            });
            setCommonSymptoms(_commonSymptoms);
            setOthersSelectCount(_count);
            // onBack();
        } else if (type == 'limbs') {
            const _limbsOrgans = limbsOrgans;
            _limbsOrgans.organs = organList;
            setLimbsOrgans(_limbsOrgans);
            let _count = 0;
            const _selectedMap = {};
            _limbsOrgans.organs.forEach((val: any) => {
                val.symptoms.forEach((v: any) => {
                    if (v.selected) {
                        _selectedMap[v.code] = v;
                        _count++;
                    }
                })
            })
            const _commonSymptoms = commonSymptoms.map((vvv: any) => {
                if (_selectedMap[vvv.code]) {
                    return {
                        ...vvv,
                        selected: true
                    }
                } else {
                    return {
                        ...vvv,
                        selected: false
                    }
                }
            });
            setCommonSymptoms(_commonSymptoms);
            setLimbsSelectCount(_count);
            // onBack();
        }
    }

    // 症状选择
    const symptomSelected = (key: number) => {
        let item = isCommonSymptoms ? commonSymptoms: activeSymptoms;
        item = JSON.parse(JSON.stringify(item));
        const _selected = item[key].selected;
        item[key].selected = !_selected;
        isCommonSymptoms ? setCommonSymptoms(item) : setActiveSymptoms(item);
        const _changedItem = item[key];
        // 还原选择计算症状条数 ↓
        let _count = 0;
        let _headOrgans = JSON.parse(JSON.stringify(headOrgans));
        _headOrgans.organs = _headOrgans.organs.map((val: any) => {
            const _symptoms = val.symptoms.map((v: any) => {
                if (v.code === item.code) {
                    v.selected = item.selected
                }
                if (v.selected) {
                    _count++;
                }
                return v;
            })
            return {
                ...val,
                symptoms: _symptoms
            }
        })
        setHeadSelectCount(_count);
        setHeadOrgans(_headOrgans);
        let _count1 = 0;
        let _chestOrgans = JSON.parse(JSON.stringify(chestOrgans));
        _chestOrgans.organs = _chestOrgans.organs.map((val: any) => {
            const _symptoms = val.symptoms.map((v: any) => {
                if (v.code === _changedItem.code) {
                    v.selected = _changedItem.selected
                }
                if (v.selected) {
                    _count1++;
                }
                return v;
            })
            return {
                ...val,
                symptoms: _symptoms
            }
        })
        setChestSelectCount(_count1);
        setChestOrgans(_chestOrgans);
        let _count2 = 0;
        let _stomachOrgans = JSON.parse(JSON.stringify(stomachOrgans));
        _stomachOrgans.organs = _stomachOrgans.organs.map((val: any) => {
            const _symptoms = val.symptoms.map((v: any) => {
                if (v.code === _changedItem.code) {
                    v.selected = _changedItem.selected
                }
                if (v.selected) {
                    _count2++;
                }
                return v;
            })
            return {
                ...val,
                symptoms: _symptoms
            }
        })
        setStomachSelectCount(_count2);
        setStomachOrgans(_stomachOrgans);
        let _count3 = 0;
        let _othersOrgans = JSON.parse(JSON.stringify(othersOrgans));
        _othersOrgans.organs = _othersOrgans.organs.map((val: any) => {
            const _symptoms = val.symptoms.map((v: any) => {
                if (v.code === _changedItem.code) {
                    v.selected = _changedItem.selected
                }
                if (v.selected) {
                    _count3++;
                }
                return v;
            })
            return {
                ...val,
                symptoms: _symptoms
            }
        })
        setOthersSelectCount(_count3);
        // setOthersOrgans(_othersOrgans);
        // let _count4 = 0;
        // let _limbsOrgans = JSON.parse(JSON.stringify(limbsOrgans));
        // _limbsOrgans.organs = _limbsOrgans.organs.map((val: any) => {
        //     const _symptoms = val.symptoms.map((v: any) => {
        //         if (v.code === _changedItem.code) {
        //             v.selected = _changedItem.selected
        //         }
        //         if (v.selected) {
        //             _count4++;
        //         }
        //         return v;
        //     })
        //     return {
        //         ...val,
        //         symptoms: _symptoms
        //     }
        // })
        // setLimbsSelectCount(_count4);
        // setLimbsOrgans(_othersOrgans);
    }

    const toComplete = () => {
        if (selectedCount > 0) {
            let _nowStep = nowStep;
            _nowStep++;
            setNowStep(_nowStep);
            setShowBody(false);
            setShowDegree(true);
            // window.history.pushState({}, document.title, '#/ae/reporting');
        } else {
            Toast.show('请先选择症状', 0.8);
        }
    }

    const onDegreeComplete = (data: any) => {
        let _nowStep = nowStep;
        if (_nowStep <= 3) {
            _nowStep++;
            setNowStep(_nowStep);
        }
        setSymptomsRecords(data);
        setShowDegree(false);
        setShowCompleted(true);
    }

    const onCompletedFinished = (data: any) => {
        setSymptomsResult(data || {});
        setShowCompleted(false);
        setShowBody(false);
        setShowResult(true);
    }

    return (
        <div className={styles.ae_reporting}>
            {/* 头颈 */}
            {
                !showResult &&
                <div className={styles.alk_head}>
                    <div className={styles.alk_head_item_active}>
                        <div className={styles.number_wrap}>
                            <div className={styles.number}>1</div>
                        </div>
                        <div className={styles.title_choose}>选择症状</div>
                        <div className={styles.title_desc}>选择您的症状</div>
                    </div>
                    <div>
                        <img src={right_db_arrow} alt="" />
                    </div>
                    <div className={`${nowStep >= 2 ? styles.alk_head_item_active : styles.alk_head_item}`}>
                        <div className={styles.number_wrap}>
                            <div className={styles.number}>2</div>
                        </div>
                        <div className={styles.title_choose}>程度判定</div>
                        <div className={styles.title_desc}>症状程度补充</div>
                    </div>
                    <div className={`${nowStep >= 3 ? '' : styles.not_actice}`}>
                        <img src={right_db_arrow} alt="" />
                    </div>
                    <div className={`${nowStep >= 3 ? styles.alk_head_item_active : styles.alk_head_item}`}>
                        <div className={styles.number_wrap}>
                            <div className={styles.number}>3</div>
                        </div>
                        <div className={styles.title_choose}>治疗方式</div>
                        <div className={styles.title_desc}>既往治疗方式</div>
                    </div>
                    <div  className={`${nowStep >= 4 ? '' : styles.not_actice}`}>
                        <img src={right_db_arrow} alt="" />
                    </div>
                    <div className={`${nowStep >= 4 ? styles.alk_head_item_active : styles.alk_head_item}`}>
                        <div className={styles.number_wrap}>
                            <div className={styles.number}>4</div>
                        </div>
                        <div className={styles.title_choose}>评测结果</div>
                        <div className={styles.title_desc}>查看测评结果</div>
                    </div>
                </div>
            }
            {/* 选择常见症状 */}
            {
                showBody && 
                <div className={styles.choose_sympton}>
                    <div className={styles.content_area}>
                        <div className={styles.sympton_title}>ALK肺癌患者常见风险症状：</div>
                        <div className={styles.sympton_content}>
                            {
                                (isCommonSymptoms ? commonSymptoms: activeSymptoms).map((v: any, key: number) =>(
                                    <div className={`${v.selected ? styles.active : styles.un_active}`} key={key} onClick={() => { symptomSelected(key)}}>
                                        {v.name}
                                    </div>
                                ))
                            }
                            {/* <div className={styles.active}>咳嗽</div>
                            <div className={styles.un_active}>咳痰</div> */}
                            {/* <div>咯血</div>
                            <div>胸痛</div>
                            <div>11</div>
                            <div>11</div>
                            <div>11</div>
                            <div>11</div> */}
                        </div>
                    </div>
                    {/* <img src={choose_sympton} alt="" /> */}
                </div>
            }
            {/* 选择身体部位症状 */}
            {
                showBody &&
                <div className={styles.ae_reporting_content}>
                    {
                        bodySelectedCount > 0 ?
                        <div className={styles.body_title}>
                            <div className={styles.body_active}>全部</div>
                            <div className={styles.body_un_active}>{
                                headSelected ? 
                                '头颈': stomachSelected ?
                                '腹部': chestSelected ?
                                '胸部': fourLimbsSelected ?
                                '四肢': othersSelected ?
                                '其他': ''
                            }</div>
                            <div className={styles.body_un_active}>未选器官</div>
                        </div>
                        :
                        <div className={styles.body_title}>
                            <img src={icon_down_down} alt="" />
                            <span>您可以点击下图中的部位查看更多症状</span>
                            <img src={icon_down_down} alt="" />
                        </div>
                    }
                    {/* <div className={styles.tip_top_wrap}>
                        <img className={styles.tip_top} src={tip_top_select} alt="" />
                        <div className={styles.tip_top_text}>请从下列5个部位中选择您出现不适的部位</div>
                    </div> */}
                    <div className={styles.area_body_container}>
                        <img className={styles.area_body} src={blue_body} alt="" />
                        <div className={`${styles.area_base} ${styles.area_head} ${headSelectCount > 0 ? styles.area_active : ''}`} onClick={ () => { headSelect()} }>
                            <div className={`${styles.area_tl_l}`}></div>
                            <div className={`${styles.area_tl_t}`}></div>
                            <div className={`${styles.area_tr_r}`}></div>
                            <div className={`${styles.area_tr_t}`}></div>
                            <div className={`${styles.area_bl_l}`}></div>
                            <div className={`${styles.area_bl_b}`}></div>
                            <div className={`${styles.area_br_r}`}></div>
                            <div className={`${styles.area_br_b}`}></div>
                            <div className={styles.area_head_top}>
                                <img className={styles.icon_head} src={headSelectCount > 0 ? head_blue : head_purple} alt="" />
                                <div className={`${headSelectCount > 0 ? styles.area_text_active : ''}`}>头颈</div>
                                {
                                    headSelectCount > 0 &&
                                    <div className={styles.symptom}>
                                        {headSelectCount}
                                        <div className={`${styles.area_tr_r}`}></div>
                                        <div className={`${styles.area_tr_t}`}></div>
                                    </div>
                                }
                            </div>
                            {/* <div className={styles.area_head_middle}>
                            </div>
                            <div className={styles.area_head_bottom}>
                                包括精神方面、五官等部位
                            </div> */}
                            <img  className={styles.line_head} src={line_head} alt="" />
                        </div>
                        <div className={`${styles.area_base} ${styles.area_chest} ${chestSelectCount > 0 ? styles.area_active : ''}`} onClick={ () => { chestSelect()} }>
                            <div className={`${styles.area_tl_l}`}></div>
                            <div className={`${styles.area_tl_t}`}></div>
                            <div className={`${styles.area_tr_r}`}></div>
                            <div className={`${styles.area_tr_t}`}></div>
                            <div className={`${styles.area_bl_l}`}></div>
                            <div className={`${styles.area_bl_b}`}></div>
                            <div className={`${styles.area_br_r}`}></div>
                            <div className={`${styles.area_br_b}`}></div>
                            <div className={styles.area_head_top}>
                                <img className={styles.icon_head} src={chestSelectCount > 0 ? chest_blue : chest_purple} alt="" />
                                <div className={`${chestSelectCount > 0 ? styles.area_text_active : ''}`}>胸部</div>
                                {
                                    chestSelectCount > 0 &&
                                    <div className={styles.symptom}>
                                        {chestSelectCount}
                                        <div className={`${styles.area_tr_r}`}></div>
                                        <div className={`${styles.area_tr_t}`}></div>
                                    </div>
                                }
                            </div>
                            <img  className={styles.line_chest} src={line_chest} alt="" />
                        </div>
                        <div className={`${styles.area_base} ${styles.area_stomach} ${stomachSelectCount > 0 ? styles.area_active : ''}`} onClick={ () => { stomachSelect()} }>
                            <div className={`${styles.area_tl_l}`}></div>
                            <div className={`${styles.area_tl_t}`}></div>
                            <div className={`${styles.area_tr_r}`}></div>
                            <div className={`${styles.area_tr_t}`}></div>
                            <div className={`${styles.area_bl_l}`}></div>
                            <div className={`${styles.area_bl_b}`}></div>
                            <div className={`${styles.area_br_r}`}></div>
                            <div className={`${styles.area_br_b}`}></div>
                            <div className={styles.area_head_top}>
                                <img className={styles.icon_head} src={stomachSelectCount > 0 ? stomach_blue: stomach_purple} alt="" />
                                <div className={`${stomachSelectCount > 0 ? styles.area_text_active : ''}`}>腹部</div>
                                {
                                    stomachSelectCount > 0 &&
                                    <div className={styles.symptom}>
                                        {stomachSelectCount}
                                        <div className={`${styles.area_tr_r}`}></div>
                                        <div className={`${styles.area_tr_t}`}></div>
                                    </div>
                                }
                            </div>
                            {/* <div className={styles.area_head_middle}>
                            </div>
                            <div className={styles.area_head_bottom}>
                                包括肝脏、肠胃肾脏等器官
                            </div> */}
                            <img  className={styles.line_stomach} src={line_stomach} alt="" />
                        </div>
                        <div className={`${styles.area_base} ${styles.area_others} ${othersSelectCount > 0 ? styles.area_active : ''}`} onClick={ () => { othersSelect()} }>
                            <div className={`${styles.area_tl_l}`}></div>
                            <div className={`${styles.area_tl_t}`}></div>
                            <div className={`${styles.area_tr_r}`}></div>
                            <div className={`${styles.area_tr_t}`}></div>
                            <div className={`${styles.area_bl_l}`}></div>
                            <div className={`${styles.area_bl_b}`}></div>
                            <div className={`${styles.area_br_r}`}></div>
                            <div className={`${styles.area_br_b}`}></div>
                            <div className={styles.area_head_top}>
                                <img className={styles.icon_head} src={othersSelectCount > 0 ? all_body_blue : all_body_purple} alt="" />
                                <div className={`${othersSelectCount > 0 ? styles.area_text_active : ''}`}>全身</div>
                                {
                                    othersSelectCount > 0 &&
                                    <div className={styles.symptom}>
                                        {othersSelectCount}
                                        <div className={`${styles.area_tr_r}`}></div>
                                        <div className={`${styles.area_tr_t}`}></div>
                                    </div>
                                }
                            </div>
                            <img  className={styles.line_others} src={line_all_body} alt="" />
                        </div>
                        {/* <div className={`${styles.area_base} ${styles.area_four_limbs} ${limbsSelectCount > 0 ? styles.area_active : ''}`} onClick={ () => { fourLimbsSelect()} }>
                            <div className={`${styles.area_tl_l}`}></div>
                            <div className={`${styles.area_tl_t}`}></div>
                            <div className={`${styles.area_tr_r}`}></div>
                            <div className={`${styles.area_tr_t}`}></div>
                            <div className={`${styles.area_bl_l}`}></div>
                            <div className={`${styles.area_bl_b}`}></div>
                            <div className={`${styles.area_br_r}`}></div>
                            <div className={`${styles.area_br_b}`}></div>
                            <div className={styles.area_head_top}>
                                <img className={styles.icon_head} src={limbsSelectCount > 0 ? limbs_blue : limbs_purple} alt="" />
                                <div className={`${limbsSelectCount > 0 ? styles.area_text_active : ''}`}>四肢</div>
                                {
                                    limbsSelectCount > 0 &&
                                    <div className={styles.symptom}>
                                        {limbsSelectCount}
                                        <div className={`${styles.area_tr_r}`}></div>
                                        <div className={`${styles.area_tr_t}`}></div>
                                    </div>
                                }
                            </div>
                            <img className={styles.line_four_limbs} src={line_limbs} alt="" />
                        </div> */}
                    </div>
                    <div className={styles.tip_bottom_wrap} onClick={toComplete}>
                        {/* <img className={styles.bootom_top} src={btn_blue} alt="" /> */}
                        <img className={styles.bootom_top} src={btn_six_side} alt="" />
                        <div className={styles.bootom_top_text}>{
                        selectedCount == 0
                        ?
                        '请先选择症状后再进行下一步'
                        :
                        `已选择 ${selectedCount} 个症状、进入下一步`
                        }</div>
                    </div>
                    <div className={styles.symptoms_selected}>
                        <div className={styles.symptoms_top}></div>
                        <div className={styles.symptoms_bottom}></div>
                    </div>
                </div>
            }
            {
                showHead &&
                <Head organs={headOrgans} activeSymptoms={activeSymptoms} onBack={onBack} onComplete={onComplete} />
            }
            {
                showChest &&
                <Chest organs={chestOrgans} commonSymptoms={commonSymptoms}  onBack={onBack} onComplete={onComplete} >
                    {/* <div className={styles.body_title}>
                        <div className={styles.body_active}>
                            全部
                        </div>
                        <div className={styles.body_un_active}>
                            胸部
                        </div>
                        <div className={styles.body_un_active}>未选器官</div>
                    </div> */}
                </Chest>
            }
            {
                showStomach &&
                <Stomach organs={stomachOrgans} commonSymptoms={commonSymptoms} onBack={onBack} onComplete={onComplete} />
            }
            {
                showLimbs &&
                <FourLimbs organs={limbsOrgans} commonSymptoms={commonSymptoms} onBack={onBack} onComplete={onComplete} />
            }
            {
                showOthers &&
                <Others organs={othersOrgans} commonSymptoms={commonSymptoms}  onBack={onBack} onComplete={onComplete} />
            }
            {
                showDegree &&
                <Degree
                    treatments={treatments}
                    headOrgans={headOrgans}
                    chestOrgans={chestOrgans}
                    stomachOrgans={stomachOrgans}
                    limbsOrgans={limbsOrgans}
                    othersOrgans={othersOrgans}
                    onBack={onBack}
                    onComplete={onDegreeComplete} 
                />
            }
            {
                showCompleted &&
                <Completed 
                    symptomRecords={symptomRecords}
                    treatments={treatments}
                    headOrgans={headOrgans}
                    chestOrgans={chestOrgans}
                    stomachOrgans={stomachOrgans}
                    limbsOrgans={limbsOrgans}
                    othersOrgans={othersOrgans}
                    onBack={onBack}
                    onCompletedFinished={onCompletedFinished}
                />
            }
            {
                showResult &&
                <Result 
                    symptomsResult={symptomsResult}
                    onBack={onBack}
                />
            }
        </div>
    )
}

export default withRouter(AeReporting);